<template>
  <div class="metric-cards" v-if="metrics && metrics.length > 0">
    <div
      v-for="(metric, index) in metrics"
      :key="index"
      class="metric-card"
    >
      <div class="metric-label">{{ metric.label }}</div>
      <div class="metric-value" :style="{ color: getMetricColor(metric) }">
        {{ formatMetricValue(metric) }}<span v-if="metric.unit && !shouldHideUnitDefault(metric)" class="metric-unit-inline">{{ metric.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetricCards',
  props: {
    // 指标数据数组
    metrics: {
      type: Array,
      required: true,
      default: () => []
      // 格式: [{ label: '标签', value: '值', unit: '单位', field: '字段名' }]
    },
    // 自定义格式化函数
    formatValue: {
      type: Function,
      default: null
      // 函数签名: (metric) => string
    },
    // 自定义颜色获取函数
    getColor: {
      type: Function,
      default: null
      // 函数签名: (metric) => string (CSS颜色值)
    },
    // 自定义单位隐藏判断函数
    shouldHideUnit: {
      type: Function,
      default: null
      // 函数签名: (metric) => boolean
    }
  },
  methods: {
    // 格式化指标显示值
    formatMetricValue(metric) {
      if (!metric) return ''
      if (this.formatValue) {
        try {
          return this.formatValue(metric.label, metric.value, metric)
        } catch (error) {
          console.warn('格式化指标值失败:', error)
          return metric.value || ''
        }
      }
      return metric.value || ''
    },
    // 获取指标值的颜色
    getMetricColor(metric) {
      if (!metric) return '#00d4ff'
      if (this.getColor) {
        try {
          return this.getColor(metric.label, metric.value, metric)
        } catch (error) {
          console.warn('获取指标颜色失败:', error)
          return '#00d4ff'
        }
      }
      // 默认颜色
      return '#00d4ff'
    },
    // 判断是否应该隐藏单位
    shouldHideUnitDefault(metric) {
      if (!metric) return false
      if (this.shouldHideUnit) {
        try {
          return this.shouldHideUnit(metric.label || metric)
        } catch (error) {
          console.warn('判断是否隐藏单位失败:', error)
          return false
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.metric-cards {
  flex-shrink: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 2列布局
  gap: 10px;
}

.metric-card {
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 4px;
  padding: 7px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .metric-label {
    font-size: 12px;
    color: #a0b3c8;
  }

  .metric-value {
    font-size: 12px; // 与左侧 stat-item 保持一致
    font-weight: bold;
    color: #00d4ff;
    white-space: nowrap;
    line-height: 1.2;

    .metric-unit-inline {
      font-size: 12px;
      margin-left: 4px;
      font-weight: normal;
    }
  }
}
</style>

